import { IsUUID } from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';

export class ReferralAssignmentDto implements Partial<BaseDto> {
  id: string;
  created: Date;
  referralId: string;
  specialistGroupMemberId: string;
}

export class CreateReferralAssignmentDto
  extends BaseCreateDto
  implements Partial<ReferralAssignmentDto>
{
  @IsUUID()
  specialistGroupMemberId: string;

  @IsUUID()
  referralId: string;
}
